<template>
  <base-performance title="Day Past Due" :empty="empty">
    <div class="row">
      <div class="col-md-6">
        <chart
          :chart-data="chartData"
          :chart-options="chartOptions"
          ref="chart"
          style="width: 200px; height: 200px; margin: auto"
        ></chart>
      </div>
      <div class="col-md-6">
        <div class="d-flex flex-column gap-16px">
          <div class="rounded border p-12px d-flex flex-column gap-4px">
            <div>
              <i class="mdi mdi-circle text-blue-200 align-middle me-1"></i>
              <span class="font-size-500 text-neutral-300">Belum Jatuh Tempo</span>
            </div>
            <div class="text-xl">{{ $numeral(datasetPercentage[0]).format("0,0") }}%</div>
          </div>
          <div class="rounded border p-12px d-flex flex-column gap-4px">
            <div>
              <i class="mdi mdi-circle text-blue-500 align-middle me-1"></i>
              <span class="font-size-500 text-neutral-300">Sudah Jatuh Tempo</span>
            </div>
            <div class="text-xl">{{ $numeral(datasetPercentage[1]).format("0,0") }}%</div>
          </div>
        </div>
      </div>
    </div>
  </base-performance>
</template>
<script>
/* eslint-disable no-unused-vars */
import BasePerformance from "@/router/views/dashboards/components/widgets/base-performance.vue";
import Chart from "./day-past-due-chart.vue";
export default {
  components: { BasePerformance, Chart },
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      chartData: {
        labels: ["Belum Jatuh Tempo", "Sudah Jatuh Tempo"],
        datasets: [
          {
            barPercentage: 0.7,
            backgroundColor: ["#3B82F6", "#BFDBFE"],
            borderColor: "white",
            hoverBorderColor: ["white", "white"],
            hoverBorderWidth: 8,
            data: []
          }
        ]
      },
      /**
       * @type {import("chart.js").ChartOptions}
       */
      chartOptions: {}
    };
  },
  mounted() {
    // this.fetchChart();
    const dueReceivables = [
      this.value.total_account_receivable_gte_1_day_pas_due,
      this.value.total_account_receivable_gte_31_day_pas_due,
      this.value.total_account_receivable_gte_61_day_pas_due,
      this.value.total_account_receivable_gte_91_day_pas_due,
      this.value.total_account_receivable_gte_121_day_pas_due
    ];
    let notYetDueReceivables = this.value.total_account_receivable_not_yet_due;
    if(notYetDueReceivables < 0.005) notYetDueReceivables = 0;

    const labels = ["belum jatuh tempo", "sudah jatuh tempo"];
    const datasets = [
      {
        backgroundColor: ["#BFDBFE", "#3B82F6"],
        borderWidth: 0.3,
        borderColor: "white",
        hoverBorderColor: ["white", "white"],
        hoverBorderWidth: 4,
        data: [notYetDueReceivables, dueReceivables.reduce((a, b) => a + b, 0)]
      }
    ];

    this.$set(this.chartOptions, "due_receivables", dueReceivables);
    this.$set(this.chartOptions, "not_yet_due_receivables", notYetDueReceivables);
    this.$set(this.chartData, "labels", labels);
    this.$set(this.chartData, "datasets", datasets);

    this.$refs.chart.refreshChart();
  },
  computed: {
    datasetPercentage() {
      const total = this.chartData.datasets[0].data.reduce((a, b) => a + b, 0);
      return this.chartData.datasets[0].data.map(value => (((value / total) * 100) || 0));
    }
  },
  methods: {
    dummyFetch() {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            data: {
              data: {
                rows: [1231, 31232]
              }
            }
          });
        }, 1000);
      });
    },
    fetchChart() {
      this.loading = true;
      this.empty = false;
      return this.$axios
        .get(this.url, {
          parameters: [
            {
              type: "date/all-options",
              value: this.dateRange,
              id: "35761b3d",
              target: [
                "dimension",
                [
                  "field",
                  "ordered_at",
                  {
                    "base-type": "type/Date"
                  }
                ]
              ]
            }
          ]
        })
        .then(response => {
          const rows = response.data.data.rows;
          if (rows.length === 0) {
            this.empty = true;
          }
          const labels = ["belum jatuh tempo", "sudah jatuh tempo"];
          const datasets = [
            {
              backgroundColor: ["#3B82F6", "#BFDBFE"],
              borderWidth: 0.3,
              borderColor: "white",
              hoverBorderColor: ["white", "white"],
              hoverBorderWidth: 8,
              // hoverBackgroundColor: "#3B82F6",
              data: rows
            }
          ];

          this.$set(this.chartData, "labels", labels);
          this.$set(this.chartData, "datasets", datasets);

          this.$refs.chart.refreshChart();
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
